import styled, { css } from 'styled-components';
import { CSkeleton } from './Skeletons.styles';

/**
 * The square icon button that sits in a card header — the Upcoming actions tile's export and
 * import buttons today.
 *
 * The box lives here once so the button and the placeholder it shows while its data loads cannot
 * drift apart: they were previously two hand-written copies of the same 52px square, and the
 * skeleton had a 6px radius against the button's 3px, so the header visibly changed shape as it
 * finished loading.
 */
const iconSquareButtonBox = css`
  height: 52px;
  width: 52px;
  border: 1px solid ${({ theme }) => theme.colors.stroke};
  border-radius: 3px;
`;

export const IconSquareButton = styled.div<{ $disabled?: boolean }>`
  ${iconSquareButtonBox};
  background-color: ${({ theme }) => theme.colors.cultured};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${({ $disabled }) => ($disabled ? 'default' : 'pointer')};
  opacity: ${({ $disabled }) => ($disabled ? 0.45 : 1)};
  * {
    user-select: none;
  }

  &:hover {
    filter: ${({ $disabled }) => ($disabled ? 'none' : 'brightness(1.015)')};
  }
`;

/** Same box, so the header does not resize or change shape when the real button replaces it. */
export const IconSquareButtonSkeleton = styled(CSkeleton)`
  ${iconSquareButtonBox};
`;
